import {
  PdfBankStatementsFormData,
  FormPdfBankStatements,
} from './components/FormPdfBankStatements';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { submitBankStatementsPdfUpload } from '../../reducers/customer-slice';
import { useQuery } from '../../util/hooks';
import { AppThunkDispatch } from '../../util/store';
import { useAppStepNavigation } from '../../util/hooks/useAppStepNavigation';
import { useEffect } from 'react';
import { FeatureFlags, useFeatures } from '../../providers/features-provider';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../routes';
import { AlertSliceError } from '../../components/alert-slice-error';

export const BankStatementsPdfUploadContent = () => {
  const query = useQuery();
  const queryParamCheckoutId = query.get('checkoutId')!;

  const { goToStep } = useAppStepNavigation();

  const dispatch = useDispatch<AppThunkDispatch>();

  const globalAuthState = useSelector((state: RootState) => state.auth);
  const globalCheckoutState = useSelector((state: RootState) => state.checkout);
  const globalCustomerState = useSelector((state: RootState) => state.customer);

  const customerId = globalAuthState.customerId || '';
  const customerNumber = globalCustomerState.customerNumber || '';
  const loading = globalCheckoutState.loading || globalCustomerState.loading;

  const history = useHistory();

  const {
    flagsConfig: { [FeatureFlags.PDF_BANK_STATEMENTS]: pdfBankStatementsFeatureFlag },
    isInitialised,
  } = useFeatures();

  // If the PDF statements feature flag is not switched on, redirect to the original bank statements IFRAME page
  // Wait for Flagsmith to initialize before checking the flag to avoid redirecting too early
  useEffect(() => {
    if (isInitialised && !pdfBankStatementsFeatureFlag) {
      history.push(ROUTES.PAYMENT_PLAN_BANK_STATEMENTS_ONLINE_BANKING + history.location.search);
    }
  }, [isInitialised, pdfBankStatementsFeatureFlag, history]);

  const handleSubmit = async (data: PdfBankStatementsFormData) => {
    const nextStep = await dispatch(
      submitBankStatementsPdfUpload(queryParamCheckoutId, customerId, data)
    );

    goToStep(nextStep);
  };

  return (
    <>
      <FormPdfBankStatements
        customerNumber={customerNumber}
        loading={loading}
        onSubmit={handleSubmit}
        alert={<AlertSliceError slice={globalCustomerState} />}
      />
    </>
  );
};
